import { inject, InjectionToken, Provider, Type } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { filterBoolean } from '@recruitee/common';
import { DataSource, DataSourceService } from '@recruitee/views-types';

export const INITIAL_DS_ID = new InjectionToken<string>('initial datasource id playground');
export const dataSourceServiceMap = new InjectionToken<Record<string, Type<DataSourceService>>>(
  'datasource service map',
);
export const dataSource$ = new InjectionToken<Observable<DataSource>>(
  'View data source observable',
);
export const dataSourceProvider$ = new InjectionToken<BehaviorSubject<DataSource | null>>(
  'View data source subject',
);
export const dataSourceService$ = new InjectionToken<Observable<DataSourceService>>(
  'Data source service observable',
);
export const dataSourceServiceProvider$ = new InjectionToken<BehaviorSubject<DataSourceService>>(
  'Data source service provider',
);
export const DataSourceMoreSettingsCmp = new InjectionToken<Type<unknown>>(
  'Data source more settings component',
);

export const dataSourceProviders = <T extends 'jobs' | 'candidates'>(
  initial: T,
  dataSourceServiceMapValue: Record<T, Type<DataSourceService>> &
    Partial<Record<'jobs' | 'candidates', Type<DataSourceService>>>,
): Provider[] => [
  { provide: dataSourceProvider$, useValue: new BehaviorSubject<DataSource | null>(null) },
  { provide: dataSource$, useFactory: () => inject(dataSourceProvider$).pipe(filterBoolean) },
  {
    provide: dataSourceServiceProvider$,
    useFactory: () =>
      new BehaviorSubject<DataSourceService>(inject(dataSourceServiceMapValue[initial])),
  },
  {
    provide: dataSourceService$,
    useFactory: () => inject(dataSourceServiceProvider$).pipe(filterBoolean),
  },
  {
    provide: dataSourceServiceMap,
    useValue: dataSourceServiceMapValue,
  },
  { provide: INITIAL_DS_ID, useValue: initial },
];
